<template>
    <b-navbar sticky toggleable="sm" type="dark" class="anavbar">
    
        <b-navbar-brand to="/" style="padding-left:10px">
            <i class="fas fa-h-square fa-2x"></i>
        </b-navbar-brand> 
    
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>


        <b-collapse id="nav-collapse" is-nav> 
            <b-navbar-nav>
                <b-nav-item to="/">Home</b-nav-item>
                <b-nav-item to="/resume">Resume</b-nav-item>
                <b-nav-item to="/projects">Projects</b-nav-item>
                <b-nav-item to="/contactme">Contact Me</b-nav-item>
                <b-nav-item to="/blog" 
                    disabled
                    v-b-tooltip.hover.html.v-warning.rightbottom 
                    title="A work in progress.<br>Stay tuned!">
                        Blog
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>

        <b-collapse is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="https://www.linkedin.com/in/henrik-davidsen" target="_blank">
                    <i class="fab fa-linkedin fa-lg"></i>
                </b-nav-item>
                <b-nav-item href="https://www.github.com/hdavidsen" target="_blank">
                    <i class="fab fa-github-square fa-lg"></i>
                </b-nav-item>
                <b-nav-item href="https://www.facebook.com/henrik.davidsen.90" target="_blank">
                    <i class="fab fa-facebook-square fa-lg"></i>
                </b-nav-item>

                <!-- TODO: Add bi(multi)lingual support
                <b-nav-item-dropdown>
                    <template v-slot:button-content>
                        <i class="fas fa-globe-europe"></i>
                    </template>
                    <b-dropdown-item href="#">EN</b-dropdown-item>
                    <b-dropdown-item href="#">NO</b-dropdown-item>
                </b-nav-item-dropdown> -->
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
export default {
    name: 'GlobalNavBar'
}
</script>

<style scoped>
.anavbar {
    background-color: rgb(55, 75, 117);
}

.navbar-dark .navbar-nav .nav-link{
      color:rgb(226, 219, 219)!important
}

</style>